import { Location } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { BaseComponent } from 'src/app/base/base.component';
import { HistoryBaseComponent } from 'src/app/history-base/history-base.component';
import { Config } from 'src/infrastructure/config';
import { OrderStatus } from 'src/infrastructure/enums/orderStatus';
import { CartLine } from 'src/models/DTO/cart/cartLine';
import { CreatedOrder } from 'src/models/DTO/orders/createdOrder';
import { OrderCollection } from 'src/models/DTO/orders/orderCollection';
import { OrderInfo } from 'src/models/DTO/orders/orderInfo';
import { OrderReturnRequests } from 'src/models/DTO/returns/orderReturnRequests';
import { ToastService } from 'src/services/core/toast/toast.service';
import { ImagesService } from 'src/services/request/images/images.service';
import { OrderService } from 'src/services/request/orders/order.service';
import { ProductService } from 'src/services/request/product/product.service';
import { OrderReturnServiceService } from 'src/services/request/returns/order-return-service.service';
import { HistoryService } from 'src/services/state/history/history.service';

@Component({
  selector: 'app-orders',
  templateUrl: './orders.component.html',
  styleUrls: ['./orders.component.css']
})
export class OrdersComponent extends HistoryBaseComponent implements OnInit {

  selectedOrder: string = "Най-нови";
  selectedFilter: string = "Всички";

  private _orders: OrderCollection = {data: [], meta: { last_page: 1}};
  private _order: string = "newest";
  private _filter: number = 0;
  private _orderReturnRequests: OrderReturnRequests = { data: [] };

  private _sorts = {
    newest: "newest",
    oldest: "oldest"
  }
  private _currentPage = 1;
  private _lastPage = 1;

  constructor(
    private ordersService: OrderService,
    private imagesService: ImagesService,
    private router: Router,
    private orderReturnsService: OrderReturnServiceService,
    private toastrService: ToastService,
    protected location: Location,
    protected historyService: HistoryService
  ) {
    super(location, historyService);
    this.loadOrders();
    // this.loadOrderReturns();
  }

  ngOnInit(): void {
  }

  private loadOrderReturns() {
    this.orderReturnsService.getAllOrderReturns(this._sorts.newest).subscribe((returns) => {
      this._orderReturnRequests = returns;
    })
  }

  private loadOrders() {
    if (this._currentPage > this._lastPage) return;
    this.ordersService.getAllOrders(Config.defaultItemsPerPage, this._currentPage, this._order, this._filter).subscribe(orders => {
      console.log('orders--->', orders);
      this._lastPage = orders.meta.last_page;
      this._orders.data.push(...orders.data);
      let numberOfImageRequests = 0;
      let batches = 1;
      for (let index = 0; index < orders.data.length; index++) {
        orders!.data[index].lines.findIndex(product => {
          numberOfImageRequests++;
          let timeoutSku = 0;
          if (numberOfImageRequests > 10) {
            numberOfImageRequests = 0;
            batches++;
            timeoutSku = 0 * 2000;
          }
          setTimeout(
            () => {
              this.imagesService.getImagesForProduct("SKU", product.sku.uuid).subscribe(image => {
                if (image.data.length) {
                  product.imageSource = image.data[0]?.original.url || '/assets/images/shared/logo.png';
                }
                else {
                  numberOfImageRequests++;
                  let timeoutProduct = 0;
                  if (numberOfImageRequests > 10) {
                    numberOfImageRequests = 0;
                    batches++;
                    timeoutProduct = 0 * 2000;
                  }
                  setTimeout(
                    () => {
                      this.imagesService.getImagesForProduct("PRODUCT", product.sku.product.uuid).subscribe(image => {
                        product.imageSource = image.data[0]?.original.url || '/assets/images/shared/logo.png';
                      })
                    },
                    timeoutProduct
                  );
                }
              })
            },
            timeoutSku
          );
        })
      }
    })
  }

  get orders() {
    return this._orders?.data || [];
  }

  get shouldShowMoreButton() {
    return this._currentPage < this._lastPage;
  }

  loadMoreOrders() {
    this._currentPage++;
    this.loadOrders();
  }

  totalForOrderWithVoucher(order: any) {
    return Number.parseFloat(order.total_gross) + Number.parseFloat(order.shipment_cost) - Number.parseFloat(order.voucher_amount);
  }

  toFixed(input: any) {
    return Number.parseFloat(input).toFixed(2);
  }

  date(date: any) {
    return new Date(date).toLocaleDateString() || ''
  }

  time(date: any) {
    return new Date(date).toLocaleTimeString() || ''
  }

  status(status: any) {
    return OrderStatus[status];
  }

  goToCategories() {
    this.router.navigate(["categories"])
  }


  goToOrder(order: any) {
    this.router.navigate(['order/' + order.uuid])
  }

  leaveReview(order: any) {
    this.router.navigate(['reviews/make/' + order.uuid])
  }

  selectOrder(label:string, order: string){
    this.selectedOrder = label;
    this._order = order;
    this.loadOrders();
  }

  selectFilter(label:string, filter: number){
    this.selectedFilter = label;
    this._filter = filter;
    this.loadOrders();
  }

  returnOptionValue(option: any) {
    if (option.option.values.length) {
      let optionSelected = option.option.values.find((value: { uuid: any; }) => value.uuid == option.value);
      return optionSelected.value;
    }
    return option.value;
  }

  basePrice(cartLine: CartLine): string[]{
    console.log('basePrice ---> cartLine: ', cartLine);
    const singleNet = Number.parseFloat(cartLine.single_net || '0.00');
    const quantity = cartLine.quantity;
    const vat = Number.parseFloat(cartLine.single_tax_amount || '0.00');
    const priceCalculated = (singleNet + vat) * quantity;
    const fixedPrice = priceCalculated.toFixed(2);
    const priceArray = fixedPrice.split('.');
    priceArray[0] = priceArray[0].toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return priceArray;
  }

  pricingInfo(cartLine: CartLine) {
    // console.log('cartLine', cartLine);
    let price = cartLine.price_per_piece;
    let priceAsString =  Number.parseFloat(price).toFixed(2);
    return  cartLine.quantity + ' x ' + priceAsString + ' лв.';
  }

  shouldShowDiscountPrice(cartLine: CartLine): boolean {
    const singleNet = Number.parseFloat(cartLine.single_net || '0.00');
    const vat = Number.parseFloat(cartLine.single_tax_amount || '0.00');
    const pieces = Number.parseFloat(cartLine.price_per_piece || '0.00');
    return singleNet + vat !== pieces;
  }

  getPriceAsFixedString(cartLine: CartLine) {
    if (!cartLine.price_per_piece) return '00.00';
    let priceCalculated =  Number.parseFloat(cartLine.price_per_piece) * cartLine.quantity
    let fixedPrice = priceCalculated.toFixed(2);
    let priceArray = fixedPrice.split('.');
    priceArray[0] = priceArray[0].toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    return priceArray;
  }

  pricingCancelledInfo(cartLine: any): string {
    const price = cartLine.single_net;
    const priceAsString =  Number.parseFloat(price).toFixed(2);
    return  (cartLine.initial_quantity - cartLine.quantity) + ' x ' + priceAsString + ' лв.';
  }

  getCancelledPriceAsFixedString(cartLine: any): string[] {
    const priceCalculated =  Number.parseFloat(cartLine.price_per_piece || '00.00') * (cartLine.initial_quantity - cartLine.quantity);
    const fixedPrice = priceCalculated.toFixed(2);
    const priceArray = fixedPrice.split('.');
    priceArray[0] = priceArray[0].toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return priceArray;
  }

  getPriceAsFixedStringFromString(sum: string) {
    let fixedPrice = sum;
    let priceArray = fixedPrice.split('.');
    priceArray[0] = priceArray[0].toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    return priceArray;
  }

  getUnitPriceBase(cartLine: CartLine): number {
    return Number(cartLine.price_per_piece) || 0;
  }

  getLineTotalBase(cartLine: CartLine): number {
    return this.getUnitPriceBase(cartLine) * (Number(cartLine.quantity) || 0);
  }

  getBaseLineTotal(cartLine: CartLine): number {
    const singleNet = Number(cartLine.single_net || '0');
    const vat = Number(cartLine.single_tax_amount || '0');
    const quantity = Number(cartLine.quantity) || 0;

    return (singleNet + vat) * quantity;
  }

  pricingInfoText(cartLine: CartLine): string {
    return `${Number(cartLine.quantity) || 0} x`;
  }

  getCancelledLineTotalBase(cartLine: any): number {
    const cancelledQty = (Number(cartLine.initial_quantity) || 0) - (Number(cartLine.quantity) || 0);
    return this.getUnitPriceBase(cartLine) * cancelledQty;
  }

  pricingCancelledInfoText(cartLine: any): string {
    const cancelledQty = (Number(cartLine.initial_quantity) || 0) - (Number(cartLine.quantity) || 0);
    return `${cancelledQty} x`;
  }

  getShipmentCostBase(order: any): number {
    return Number(order.shipment_cost) || 0;
  }

  getOrderGrandTotalBase(order: any): number {
    return Number(this.totalForOrderWithVoucher(order)) || 0;
  }

  getTotalPriceAsFixedString(price: string) {
    if (!price) return '00.00';
    let fixedPrice = Number.parseFloat(price).toFixed(2);
    let priceArray = fixedPrice.split('.');
    priceArray[0] = priceArray[0].toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    return priceArray[0] + '.' +priceArray[1];
  }

  goToProduct(productPerOrg: CartLine) {
    if (productPerOrg.sku.product.deleted_at) {
      this.toastrService.info("Продуктът вече не е наличен.");
      return;
    }
    this.router.navigate(['product/' + productPerOrg.sku.product.uuid + '/' + 'none'])
  }

}
